// -----------------------------------------------------------------[ LIBS ]--------------------------------------------------------------//

//---------- AJAX ----------------------------------------------//
import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';

//---------- SMOOTH SCROLL -------------------------------------//
import LocomotiveScroll from 'locomotive-scroll';

//---------- ANIMATION AND SCROLL CONTROLL (TRIGGER) -----------//
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// plugin registry gsap
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

//---------- LAZYLOAD IMAGES -----------------------------------//
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import lazySizes from 'lazysizes';

lazySizes.cfg.loadMode 	= 1; // default to 2
lazySizes.cfg.expFactor = 1; //1.1; // default 1.5	
lazySizes.cfg.expand 	= 0; //100; // 370-500
lazySizes.cfg.init 		= false;


//---------- LOADING BAR ---------------------------------------//
import NProgress from 'nprogress';

//---------- UTILS ---------------------------------------------//
// import { debounce as _debounce } from 'underscore';

//---------- MOUSE/TOUCH DETECTION -----------------------------//
import detectIt from 'detect-it';

import { clearAllBodyScrollLocks } from 'body-scroll-lock';

// this is injected in libs-head
//import SVGInject from '@iconfu/svg-inject';

// -----------------------------------------------------------------[ CONTROLLERS ]-----------------------------------------------------//
import Layout 	from './layout';
import WIDGETS 	from './widgets';
import EFFEX  	from './effex';


// ---- GLOBALS ?? (ESLINT don't bother) -----------------------//
let ga = window.ga, gtag = window.gtag, console = window.console;


// -----------------------------------------------------------------[ MAIN CLASS ]-----------------------------------------------------//
export default class{ // export class Main
	
	constructor(options) {

		// OPTIONS
		this.defaults = {
			is_ajax 				: true,
			time_fade_in 			: 0.6,
			time_fade_out 			: 0.4,
			is_locomotive			: true,
			is_locomotive_touch		: true,
			$scroll_el				: 'body',
			destroyScroll			: false,
			debug					: false,
			project_name 			: 'New Project',

			slide_transition        : true,

			admin_button        	: '.wordpress-edit-button',

			GA_MEASUREMENT_ID 		: 'UA-23082040-1',
		    GA_TAG_MANAGER 			: 'GTM-NW4KZZ',

			preventURLS				: [
               // These are set in app.js
            ]
		}

		this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 	= 'main';

		// VARS
		this.$window 	= $(window);
		this.$doc 		= $(document);
		this.$html 		= $('html');
		this.$body 		= $('body');

		this.detectIt();

		// just in case, eliminate locomotive scroll for touch devices if specified and ie11 (unless polyfills)
		if ( this.$html.hasClass( 'touch' ) && !this.options.is_locomotive_touch ){
			this.options.is_locomotive = false;
		}		
		
		if ( this.$html.hasClass( 'ie11' ) ){

			// sorry ie11 fails (unless polyfills)
			this.options.is_locomotive = false;

			// Sorry ie11, you fall back with normal page load ...
			this.options.is_ajax = false;
		}
		
		// say ScrollTrigger (See EFFEX) which elementate is the scrolling object (See Effex scroller parameter in ScrollTrigger Effects )
		if ( !this.options.is_locomotive ){
			this.options.$scroll_el = 'body';
		}

	}

	init(){

		this.initAjax();

		this.initScroll(true);

		// this.debounceResize(true);

		lazySizes.init();

		if ( !this.options.is_ajax ){
			this.onOnceReady();
		}

		this.initLoading();

		//----------------------------------------------------------------[ CONTROLLERS ] ---------------------------------------------------------------//
		// All JS Effects (Mostly Scroll Triggers )
		this.EFFEX 		= new EFFEX( { main: this, debug: this.options.debug } );

		// Widgets inits
		this.WIDGETS 	= new WIDGETS( { main: this } );

		// All HTML interface (Menus, Mobile Panels, etc.)
		this.LAYOUT  	= new Layout({ main: this, skip_intro: this.options.skip_intro } );

		this.initPageSpecific(this.$body, true, true);

		this.outlineInAccessibleWay();

		this._logFOUO( this.options.project_name );

	}

	// -----------------------------------------------------------------[ MOUSE/TOUCH DETECTION ]-------------------------------------------------------//
	detectIt(){
		// https://github.com/rafgraph/detect-it#readme
		switch( detectIt.deviceType ){
			//'mouseOnly' / 'touchOnly' / 'hybrid'
			case 'mouseOnly':
				this.$html.addClass( 'no-touch' );
				break;
			case 'touchOnly':
				this.$html.addClass( 'touch' );
				break;
			default:
				// 'mouse' / 'touch';
				this.$html.addClass( detectIt.primaryInput === 'mouse' ? 'hybrid no-touch' : ' hybrid touch' );
		}
	}

	// -----------------------------------------------------------------[ RESIZE HANDLER ]--------------------------------------------------------------//
	/*
	debounceResize(b){
	  if ( b ){
		// debounce resize
		this._debResize = _debounce( () => this.onResize(), 77 );
		this.$window.on( 'resize', this._debResize );
		// Listen for orientation changes
		window.addEventListener("orientationchange", ()=> this.onOrientationChange(), false);
	  }
	  else{
		if ( this._debResize ){
		  this._debResize.cancel();
		  this.$window.off( 'resize', this._debResize );
		}        
		// Listen for orientation changes
		window.removeEventListener("orientationchange", ()=> this.onOrientationChange(), false);
	  }
	}

	onOrientationChange(){
		//console.log( 'onOrientationChange');
		setTimeout( ()=>this.onResize(), 177 );
	}

	onResize(){

	}
	*/

	// -----------------------------------------------------------------[ INIT BARBA ]--------------------------------------------------------------//
	initAjax(){
		if ( this.options.is_ajax ){ 

			// tell Barba what plugins to use
			barba.use(barbaPrefetch);

			barba.init({
				
				debug: this.options.debug,

				// default 2000
				timeout: 7000, 

				// wait if a link is clicked and there is a page transition running
				preventRunning: true,

				prevent: ({ el }) => {

console.log('----- Checking prevent:');

					let $a = $(el), href = $a.attr( 'href' ), i = this.options.preventURLS.length;

console.log('href', href);

					while ( i-- ){
console.log('checking', this.options.preventURLS[ i ]);
						if ( href.indexOf( this.options.preventURLS[ i ] ) !== -1 ){
console.log('TRUE!!!');
							return true
						}						
					}
					
					return el.classList && el.classList.contains('no-barba')

				},

				/*
				prevent: ( o ) =>{
					
					let $a = $(o.el), href = $a.attr( 'href' );

					console.log( href );

					if ( $a.attr( 'target' ) === '_blank' ){
						
						console.log( 'QUIIIIIIIIIIIIIII' );

						return false;
					}
				},
				*/
				

				transitions: [

					// --------------------------- DEFAULT TRANSITION --------------------------------//
					{

						name: 'default-transition', // slide_transition, or slided_transition = false => fade

						once: () => this.onOnceReady(),

						before: (data) => this.barba_commons('before', data),

						// TRANSITION ON CURRENT PAGE
						leave: (data) => {

							// barba VIEW!
							let checkView	= this.barba_is_view( $(data.current.container), data ), 
								is_view 	= checkView[0], 
								$container	= checkView[1],
								duration = this.options.time_fade_out;

								//console.log( 'fade out, t = ' + duration );

							if ( this.options.slide_transition && !is_view ){
								let t = gsap.timeline();

								t.fromTo( $container, {y: 0 },{y: -50, opacity: 0, duration: duration, ease: 'Power3.easeOut'});
								t.fromTo( $('#curtain'), {y:"100%"}, {y:"0%",ease: 'Power3.easeOut', duration: duration }, '-=' + duration );
								
								return t; 
							}
							else{

								// fade out
								return gsap.to( $container, {
									opacity: 0,
									duration: duration
								});
							}
						},

						afterLeave: (data) => this.barba_commons('afterLeave', data),

						//------> Here is when data.next.container is added to the DOM!

						beforeEnter: (data) => this.barba_commons('beforeEnter', data),

						// TRANSITION ON NEXT PAGE
						enter: (data) => {

							// barba VIEW!
							let checkView	= this.barba_is_view( $(data.next.container), data ), 
								is_view 	= checkView[0], 
								$container	= checkView[1],
								duration = this.options.time_fade_in;

								//console.log( 'fade in, t = ' + duration );

							if ( this.options.slide_transition && !is_view ){
								let t = gsap.timeline();
								
								t.fromTo( $('#curtain'), {y:"0%" },{y:"-100%", ease: 'Power3.easeOut', duration: duration});
								t.fromTo( $container, {y: 300, opacity:0 },{y: 0, opacity:1, duration: duration, ease: 'Power3.easeOut', onUpdate:()=>{this.afterCompletePageTransitions()},onComplete: ()=>{
									// eliminate tranform so if there are pinned elemnet they behave correctly
									gsap.set( $container, {clearProps:"all"});
									this.afterCompletePageTransitions()
								}}, '-=' + duration );							
								
								return t;

							}
							else{

								// fade In
								return gsap.from( $container, {
									opacity: 0,
									duration: duration,
									onComplete: () => { this.afterCompletePageTransitions() } 
								});
							}						
						},

						after: (data) => this.barba_commons('after', data)

						/*
						barba LIFECYCLE
						https://barba.js.org/docs/getstarted/lifecycle/
						*/
						/*
						once: data => this.ajaxEvent(data, 'once'),
						before: data => this.ajaxEvent(data, 'before'),
						beforeLeave: data => this.ajaxEvent(data, 'beforeLeave'),
						leave: data => this.ajaxEvent(data, 'leave'),
						afterLeave: data => this.ajaxEvent(data, 'afterLeave'),

						//------> Here is when data.next.container is added to the DOM!
						
						beforeEnter: data => this.ajaxEvent(data, 'beforeEnter'),
						enter: data => this.ajaxEvent(data, 'enter'),
						afterEnter: data => this.ajaxEvent(data, 'afterEnter'),
						after: data => this.ajaxEvent(data, 'after')
						*/

					}

					// --------------------------- CUSTON TRANSITION --------------------------------//
					/*
					,{
						name: 'tree-to-tree',
						from: {
							namespace: [
								'single-hort-collection'
							]
						},
						to: {
							namespace: [
								'single-hort-collection'
							]
						},
						before: (data) => this.barba_commons('before', data),
						beforeEnter: (data) =>{

							console.log( 'HELOOOOOOOOO' );

							// append new container to the old
							$(data.current.container).append( $(data.next.container) );
							// remove old container
							//$(data.current.container).remove();
							// change body classes
							this.setBodyClass( data.next.html );
							// init new page
							this.initPageSpecific( $(data.next.container), true, false );
							// init scroll
							//this.initScroll( true );
							// set scroll
							//this.setPositionScrollAfterPageEnter( data );
							// track page view
							this.setGA( window.location.pathname );
							// set loading
							this.setLoading(false);

						}
					}
					*/
					// --------------------------- END CUSTON TRANSITION ------------------------------//
					
				]
			})
		}
	}

	// -----------------------------------------------------------------[ BARBA UTILS ]--------------------------------------------------------//
	barba_is_view( $container, data ){
		if ( $(data.trigger).hasClass( 'barba-view' ) ){
			let $view = $container.find( '.' + $(data.trigger).attr( 'data-view' ) );
			if ( $view.length > 0 ){
				return [true,$view];
			}
		}
		return [false,$container];
	}

	barba_commons( mode, data ){
		switch ( mode ){
			case 'before':
				this.setInitLoadTime();
				// set loading
				this.setLoading(true);
				// used for managing back buttom
				this.recordState( true, data );
			break;
			case 'afterLeave':
				this.initScroll( false );
				this.initPageSpecific( $(data.current.container), false, false );
			break;

			//------> Here is when data.next.container is added to the DOM!

			case 'beforeEnter':
				// remove old container
				$(data.current.container).remove();
				// change body classes
				this.setBodyClass( data.next.html );
				// init new page
				this.initPageSpecific( $(data.next.container), true, false );
				// init scroll
				this.initScroll( true );
				// set scroll
				this.setPositionScrollAfterPageEnter( data );
				// track page view
				this.setGA( window.location.pathname );
				// set loading
				this.setLoading(false);
				// 
				this.updateAdminButton();
			break;
			case 'after':
			break;
		}
		this.LAYOUT.onBarbaChangeState( mode, data );
	}

	barba_triggerURL( url, $el ){
		if ( this.options.is_ajax ){
			barba.go( url, $el[0] );
		}
		else{
			document.location = url;
		}
	}

	barba_history_add( url, $el, title ){
		if ( this.options.is_ajax ){
			barba.history.add( url, $el[0] );
			if ( title ){
				this.changeHTMLTitle( title );
			}
		}
	}
	
	barba_history_previous(){
		return barba.history.previous;
	}

	setBodyClass( html ){
		//console.log( html );
		let parser = new DOMParser(), doc;
		doc = parser.parseFromString( html, "text/html");
		this.$body.attr( 'class', doc.body.getAttribute('class') );
		html = parser = doc = null;
	}

	changeHTMLTitle( str ){
		$('title').text( str );
	}

	onOnceReady(){
		// this.$body.addClass( 'after-fade-in' );
		this.setLoading( false );
	}
	// -----------------------------------------------------------------[ END BARBA ]--------------------------------------------------------------//


	// -----------------------------------------------------------------[ SCROLL ]-----------------------------------------------------------//
	
	initScroll(b) {
		//console.log( 'initScroll, b = ' + b );		
		if ( this.options.is_locomotive ){
			let $el = $(this.options.$scroll_el); //, firstTime = this.scroll === undefined;
			$el.data( 'scrollX', 0 );
			$el.data( 'scrollY', 0 );
			if ( $el.length ){
				if ( this.scroll ){
					if ( this.options.destroyScroll ){
						document.removeEventListener('lazyloaded', ()=>this.scroll.update() );
						this.scroll.destroy();
						this.scroll = null
					}
					if ( !b ) return;
				}


				if ( !this.scroll || this.options.destroyScroll ){

					// INIT LocomotiveScroll
					let lscroll = new LocomotiveScroll({
						el: $el[0],
						smooth: true,
						smoothMobile: this.options.is_locomotive_touch,
						getSpeed: true,
						getDirection: true,
						useKeyboard: true,
						repeat: false
					});
					this.scroll = lscroll;

					lscroll.on( 'scroll', (e) => {
						$el.data( 'scrollX', e.scroll.x );
						$el.data( 'scrollY', e.scroll.y );
						//console.log( e.scroll );
						
						// this.EFFEX.hideDesktopHeader( e.direction === 'down' );
					});
					// each time Locomotive Scroll updates, tell ScrollTrigger to update too (sync positioning)
					lscroll.on("scroll", ScrollTrigger.update);

					// tell ScrollTrigger to use these proxy methods for the ".smooth-scroll" element since Locomotive Scroll is hijacking things
					ScrollTrigger.scrollerProxy( $el[0], {
						scrollTop(value) {
							return arguments.length ? lscroll.scrollTo(value, 0, 0) : lscroll.scroll.instance.scroll.y;
						}, // we don't have to define a scrollLeft because we're only scrolling vertically.
						getBoundingClientRect() {
							return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
						},
						// LocomotiveScroll handles things completely differently on mobile devices - it doesn't even transform the container at all! So to get the correct behavior and avoid jitters, we should pin things with position: fixed on mobile. We sense it by checking to see if there's a transform applied to the container (the LocomotiveScroll-controlled element).
						pinType: $el[0].style.transform ? "transform" : "fixed"
					});


					// call update on images loaded!!!!
					document.addEventListener('lazyloaded', ()=>this.scroll.update() );

				}
				else{
					this.afterCompletePageTransitions()					
				}

				setTimeout( ()=>this.initEffex(true), 17 );

			}
		}
	}
	

	afterCompletePageTransitions(){
		if ( this.options.is_locomotive ){
			ScrollTrigger.refresh();
			this.scroll.update();
		}
	}

	recordState( b, data ){
		if ( b ){
			if ( data.trigger !== 'back' && data.trigger !== 'forward' ){
				this.prevSTATE = {
					html : data.current.html,
					scroll: this.getPositionScroll()
				}
			}
		}
		else{
			this.prevSTATE = false;
		}
	}

	setPositionScrollAfterPageEnter( data ){
		let y = 0;
		if ( data.trigger === 'back' || data.trigger === 'forward' ){
			if ( this.prevSTATE ){
				y = this.prevSTATE.scroll.y;
				this.recordState(false);
			}
		}			
		if ( this.scroll ){
			this.scroll.scrollTo( y, 0, 0 )
		}
		else{
			gsap.to(this.$window, {duration: 0, scrollTo: y});
		}
	}

	getPositionScroll(){
		let o = {};
		if ( this.scroll && this.options.is_locomotive && this.options.is_smooth ){
			o.x = $(this.scroll.el).data('scrollX');
			o.y = $(this.scroll.el).data('scrollY');
		}
		else{
			o.x = this.$window.scrollLeft();
			o.y = this.$window.scrollTop();
		}
		return o;
	}

	// -----------------------------------------------------------------[ UTILS ]--------------------------------------------------------------//
	initLoading(){
		if ( ! this.options.is_ajax ){
			return;
		}
		if ( NProgress ){
			NProgress.configure({ 
				trickleSpeed: 77 
			});
		}
	}

	setLoading(b){
		if ( ! this.options.is_ajax ){
			return;
		}
		if ( NProgress ){
			if ( b ){
				NProgress.start();
				this.$body.addClass( 'page-loading' );
			}
			else{
				NProgress.done();
				this.$body.removeClass( 'page-loading' );
			}
		}
	}

	log( str, args ){
		if ( console ){
			if ( args ){
				return console.log( str, args );
			}
			console.log( str );
		}
	}

	initLazyloading(){
		lazySizes.cfg.loadMode 	= 1;
		lazySizes.init();
	}

	// -----------------------------------------------------------------[ PAGES FUNCTIONS ]---------------------------------------------------//
	initPageSpecific($context, b, firstTime){
		//this.log( 'initPageSpecific, b = ' + b );
		this.WIDGETS.initWidgets($context, b, firstTime);

		if ( b ){
			
			this.initLazyloading();

			if ( !this.options.is_locomotive ){
				// Effex are called after the scroll is initiated
				this.initEffex(true);
			}
			//console.log( "lazySizes.cfg.loadMode = " + lazySizes.cfg.loadMode )

			this.initGAEvents();
            this.initAddToCalendar(true);
		}
		else{
			this.initEffex(false);

			clearAllBodyScrollLocks();
		}
	}

	//------------------------------- call after a page load via jax ouside barba somewhere (eg. auto load next news) -----------------------//
	onLoadAjaxContent( href, $trigger, html, addHistory=false ){

		let parser, doc, a, title;

		this.initPageSpecific(this.$body, false, false );
		setTimeout( ()=>this.initPageSpecific(this.$body, true, false ), 120 );
			

		// ---------- create 'a' trigger --------------//
		a = document.createElement( 'a' );
		a.href = href;
		//------------ History state (change url ) -----//

		//console.log( addHistory );
		parser = new DOMParser();
		doc = parser.parseFromString( html, "text/html");
		title = doc.title;


		if ( addHistory ){
			//------------ Change HTML Page Title ----------//
			this.changeHTMLTitle( title );
			this.barba_history_add( href, $(a),  title );
		}

		html = parser = doc = null;
		
		// ----------- Google analythics ---------------//
		this.setGA ( a.pathname );
		this.setGAEvent( 'Load Next Page', 'scroll trigger', title, a.pathname );
		
	}

	// -----------------------------------------------------------------[ EFFEX ]--------------------------------------------------------------//
	initEffex(b){
		//this.log( 'initEffex, b = ' + b );
		if( b ){
			this.EFFEX.init();
			if ( this.options.is_locomotive && this.scroll ){
				// each time the window updates, we should refresh ScrollTrigger and then update LocomotiveScroll. 
				ScrollTrigger.addEventListener("refresh", ()=>this.scroll.update() );
				// after everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
				ScrollTrigger.refresh();
			}

		}
		else{
			if ( this.options.is_locomotive && this.scroll ){
				// each time the window updates, we should refresh ScrollTrigger and then update LocomotiveScroll. 
				ScrollTrigger.removeEventListener("refresh", ()=>this.scroll.update() );

			}
			this.EFFEX.destroy();
		}		
	}

	//------------------------------------------------------------------[ GOOGLE ANALYTHICS ]--------------------------------------------------//
	setGA( pathname ){

		if ( this.isLoggedIn() ){
			return;
		}

		// this.log( 'setGA, pathname = ' + pathname + ', gtag = ' + gtag + ', ga = ' + ga + ', page_title = ' + $('title').text() );
		
		// this.log( 'set metric1: page_load_time = ' + this.getLoadTime() );

		if ( gtag ){
			gtag(	
				'config', 
				this.options.GA_MEASUREMENT_ID,
				{
					'page_title' : $('title').text(),
					'page_path': pathname 
				}
			);


			// Maps 'metric1' to 'page_load_time'.
			gtag(
				'config', 
				this.options.GA_MEASUREMENT_ID, 
				{
					'custom_map': {
						'metric1': 'page_load_time',
						'metric2': 'virtual_page_view'
					}
				}
			);
			// Sends an event that passes 'page_load_time' as a parameter.
			gtag('event', 'page_load_time_metric', { 'page_load_time': this.getLoadTime(), 'virtual_page_view': 1 });

		}
		else if ( ga ){
			ga('set', 'page', pathname );
			ga('send', 'pageview')
		}
		
	}

	setInitLoadTime(){
		this.time_click = Date.now();
	}
	getLoadTime(){
		return (Date.now() - this.time_click)/1000;
	}

	setGAEvent( category, action, label, value ){

		if ( this.isLoggedIn() ){
			return;
		}

		/*
			action: 	text, 		required
			category: 	text, 		required
			label: 		text, 		(optional)
			value: 		integer, 	(optional)
		*/
		
		// this.log( 'setGAEvent, category = ' + category + ', action = ' + action + ', label = ' + label + ', value = ' + value );
		
		if ( gtag ){
			gtag( 	
				'event', 
				action, 
				{
					'event_category': category,
					'event_label': label,
					'value': value
				}
			);
		}
		else if ( ga ){
			ga('send', 'event', category, action, label, value );
		}
		
	}

	// call each time from initPageSpecific to hook events need as button clicks ...
	initGAEvents(){
		let title = $('#hidden-page-title').text();
		const 	loc = document.location,
				queryString = loc.search;

		if ( title === '' ){
			title = $('title').text();
		}

		// event register button
		$('a.event-register').on( 'click', ()=>this.setGAEvent( 'Event Register', 'click', title, loc.href ) );

		// support click to Donor Forms
		$('a.ga-to-donors-forms').on( 'click', (e)=>this.setGAEvent( 'Donor Forms', 'click', title, $(e.currentTarget).text(), $(e.currentTarget).attr('href') ) );

		// audio player
		$('a.open-audio-player').on( 'click', (e)=>this.setGAEvent( 'Audio Play', 'click', $(e.currentTarget).attr( 'data-title'), $(e.currentTarget).attr('data-audio-src') ) );

		// video window
		$('a.open-video-window').on( 'click', (e)=>this.setGAEvent( 'Video Play', 'click', $(e.currentTarget).find('span.visually-hidden').html() ) );

		// pdf download
		$('.download-pdf a').on( 'click', (e)=>this.setGAEvent( 'PDF Download', 'click', title, $(e.currentTarget).attr('href') ) );

		// qr codes
		if ( window.URLSearchParams ){
			const urlParams = new URLSearchParams(queryString);
			const ref = urlParams.get('ref');
			if ( ref === 'qr' ){
				this.setGAEvent( 'QR CODE', 'landing', title, loc.origin + '' + loc.pathname )
			}
		}
	}


    //------------------------------------ ADD TO CALENAR -------------------------------------------------//
    initAddToCalendar(b){

        let el;

        console.log('-----> initAddToCalendar');
        setTimeout(function(){addeventatc.refresh();}, 200);

        // This should only be called on Pjax requests, the script automatically triggers on initial page view (weird).
        // if (( el = $('.add-to-calendar') )) {
        //     el.each(function(){
        //         createCalendar(this);
        //     });
        // }

    }

	//----------------------------------------------------------------[ UTILS ]------------------------------------------------------------//
	getPageID(){
		let classes, i, c, search_class;
		classes = this.$body.attr( 'class' ).split( ' ' );
		search_class = this.$body.hasClass( 'page-template' ) ? 'page-id-' : 'postid-';

		i = classes.length;
		while( i-- ){
			c = classes[i];
			if ( c.indexOf( search_class ) !== -1 ){
				return c.split( search_class )[1];
				break;
			}
		}
		return false;
	}

	updateAdminButton(){
		let  $el = $( this.options.admin_button ), id, url, href;
		if ( $el.length <= 0 ){
			return;
		}
		
		id = this.getPageID();
  
		if ( id !== false ){
			href = $el.find( 'a' ).attr( 'href' );
			if ( href ){
				if ( href.indexOf( '?' ) !== -1 ){
					url = href.split( '?' )[0];
					$el.find( 'a' ).attr( 'href', url + '?post=' + id + '&action=edit' );
				}
			}
		}
	}

	isLoggedIn(){
		return this.$body.hasClass( 'logged-in' );
	}

	/*
		Remove the Outline in an Accessible Way
		https://betterprogramming.pub/a11y-never-remove-the-outlines-ee4efc7a9968
		https://github.com/nuclei/unfocus

	*/
	outlineInAccessibleWay(){

	
		let styleText = '::-moz-focus-inner{border:0 !important;}:focus{outline: none !important;',
			unfocus_style = document.createElement('STYLE');

		window.unfocus = function(){

			document.getElementsByTagName('HEAD')[0].appendChild(unfocus_style);

			document.addEventListener('mousedown', function(){
				unfocus_style.innerHTML = styleText+'}';
			});
			document.addEventListener('keydown', function(){
				unfocus_style.innerHTML = '';
			});
		};

		unfocus.style = function(style){
			styleText += style;
		};

		unfocus();
	
	}


	// -----------------------------------------------------------------[ FOUO SIGNATURE ]-----------------------------------------------------//
	_logFOUO( str ){
		this.log( '' );
		this.log('%c' + str, 'color: white; background-color: black; font-size: 12px; line-height: 28px; padding: 10px 15px 8px 15px; font-family: Helvetica;' );
		this.log( '' );  
	}

}
